<template>
  <v-simple-table>
    <template v-slot:default>
      <tbody>
        <tr v-for="task in uploadTasks" :key="'task-' + task.name">
          <td class="ma-0">
            <span class="text-body-dark">{{ task.name }}</span>
          </td>
          <td class="ma-0">
            <v-progress-linear
              :value="task.progress"
              color="primary"
              background-color="#d8d8d8"
            ></v-progress-linear>
          </td>
        </tr>
        <tr v-for="item in items" :key="item.name">
          <td class="ma-0">
            <a
              href=""
              @click.prevent="openFile(item)"
              :class="{ disabled: item.loading }"
            >
              {{ item.name }}
            </a>
          </td>
          <td class="ma-0" style="max-width: 100px">
            <transition name="fade">
              <v-row justify="end" v-if="item.loading">
                <v-progress-circular
                  size="18"
                  width="2"
                  indeterminate
                ></v-progress-circular>
              </v-row>
              <v-row justify="end" v-else>
                <v-col cols="2" class="mx-2">
                  <feature name="jobs" variant="write" data="jobs">
                    <v-btn x-small icon @click.prevent="deleteFile(item)"
                      ><v-icon>mdi-minus-circle</v-icon></v-btn
                    >
                  </feature>
                </v-col>
                <v-col cols="2">
                  <v-btn x-small icon @click.prevent="downloadFile(item)"
                    ><v-icon>mdi-download</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </transition>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { storage } from '@/firebaseConfig'
export default {
  name: 'FileList',
  props: {
    relativePath: {
      type: String,
      default: 'uploads',
    },
    uploadTasks: {
      type: Array,
      default: () => [],
    },

    value: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [...this.value],
      mLoading: this.loading,
    }
  },
  computed: {
    ...mapGetters(['companyId']),
    fullPath() {
      return `companies/${this.companyId}/${this.relativePath}`
    },
    storageRef() {
      return storage.ref().child(this.fullPath)
    },
  },
  methods: {
    ...mapActions(['showError', 'showDeletionSuccess']),
    async loadItems() {
      try {
        this.mLoading = true
        const result = await this.storageRef.listAll()
        this.items = result.items
      } catch (error) {
        console.error(error)
      } finally {
        this.mLoading = false
      }
    },
    itemDataType(item) {
      const parts = item.name.split('.')
      return parts[parts?.length ?? 0] ?? ''
    },
    async getFileDownloadURL(file) {
      if (!file.downloadURL) {
        try {
          file.loading = true
          const fileRef = this.storageRef.child(file.name)
          const downloadURL = await fileRef.getDownloadURL()
          file.downloadURL = downloadURL
        } finally {
          file.loading = false
        }
      }

      return file.downloadURL
    },
    async openFile(file) {
      if (file.loading) {
        return
      }

      try {
        const url = await this.getFileDownloadURL(file)
        window.open(url)
      } catch (error) {
        console.error(error)
        this.showError(
          '<b>Failed.</b><br/>' + error.message ??
            'Please try again later or contact support'
        )
      }
    },
    async downloadFile(file) {
      if (file.loading) {
        return
      }

      try {
        const url = await this.getFileDownloadURL(file)
        var xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.onload = () => {
          const blob = xhr.response
          const a = document.createElement('a')
          a.href = window.URL.createObjectURL(blob)
          a.download = file.name
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          a.parentElement.removeChild(a)
        }
        xhr.open('GET', url)
        xhr.send()
      } catch (error) {
        console.error(error)
        this.showError(
          '<b>Failed.</b><br/>' + error.message ??
            'Please try again later or contact support'
        )
      }
    },
    async deleteFile(file) {
      const confirmed = await this.$confirm(
        `Please confirm that you want to delete '${file.name}' file`,
        { title: `Delete '${file.name}'?` }
      )
      if (confirmed === true) {
        try {
          const fileRef = storage.ref().child(file.location.path_)
          await fileRef.delete()
          this.items = this.items.filter((el) => el.name !== file.name)
          this.showDeletionSuccess('File has been deleted')
        } catch (error) {
          console.error(error)
          this.showError(
            '<b>Failed to delete.</b><br/>' + error.message ??
              'Please try again later or contact support'
          )
        }
      }
    },
  },
  created() {
    this.loadItems()
  },
  watch: {
    uploadTasks() {
      this.loadItems()
    },
    items(newVal) {
      this.$emit('input', newVal)
    },
    mLoading(newVal) {
      this.$emit('loading', newVal)
    },
  },
}
</script>

<style lang="sass" scoped>
.fileText
  text-overflow: ellipsis
  overflow: hidden

tbody
  tr:hover
    background-color: transparent !important

a
  @include body_dark
  &.disabled
    cursor: not-allowed
    color: $inactive
</style>